<template>
  <div class="book">
    <div class="item" v-for="(book,index) in list" :key="index" @click="toPage(book)">
      <img v-if="book.has_coupon == 1" class="coupon" src="@/assets/images/group/quan.png" alt />
      <img class="cover" :src="book.cover_img" alt />
      <div>
        <div class="info" :class="{'pt10':book.has_coupon == 1}">
          <div class="info-base">
            <p class="title">{{book.book}}</p>
            <p class="author">作者：{{book.author}}</p>
            <p class="p1" v-if="book.user_num">{{book.user_num}}人团</p>
          </div>
          <div class="number" v-if="book.already_join_number">
            <div>
              <img :src="book.group_user_avatars[1] ? book.group_user_avatars[1] : default_img" />
              <img
                class="img2"
                :src="book.group_user_avatars[2] ? book.group_user_avatars[2] : default_img"
              />
              <img
                class="img1"
                :src="book.group_user_avatars[0] ? book.group_user_avatars[0] : default_img"
              />
            </div>
            <p class="num">{{book.already_join_number}}人已拼</p>
          </div>
        </div>
        <div class="footer">
          <p class="p1">
            <icon-price size="mini"></icon-price>
            <font v-if="book.spell_price">{{book.spell_price | toFixPrice}}</font>
            <font v-else>免费</font>
          </p>
          <p class="p2">
            单买:
            <icon-price size="mini"></icon-price>
            <font>{{book.price | toFixPrice}}</font>
          </p>
          <div class="spell-btn">去拼团</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BookSpell",
  props: ["list"],
  data() {
    return {
      default_img: require("@/assets/images/group/default-avatar.png")
    };
  },
  methods: {
    toPage(item) {
      if (this.$store.state.app) {
        this.$pub.appJump(`book-detail?id=${item.book_id}`);
      } else {
        this.$router.push({
          name: "BookDetail",
          query: { id: item.book_id }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.book {
  .item {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.07);
    border-radius: 20px;
    padding: 30px 20px;
    margin-bottom: 30px;
    display: flex;
    position: relative;
    .coupon {
      position: absolute;
      right: 30px;
      top: 0px;
      width: 32px;
      height: 38px;
    }
    .cover {
      width: 172px;
      height: 242px;
      margin-right: 30px;
      flex: none;
    }
    > div {
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: space-between;
      .info {
        display: flex;
        .info-base {
          flex: 1;
          .title {
            line-height: 42px;
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.85);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .author {
            padding-top: 8px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(140, 140, 140, 1);
            line-height: 40px;
          }
          .p1 {
            display: inline-block;
            padding: 8px 10px;
            background: #fde9e9;
            border-radius: 4px;
            font-size: 18px;
            color: #ee1f1f;
          }
        }
        .number {
          flex: none;
          > div {
            position: relative;
            width: 81px;
            height: 54px;
            img {
              width: 54px;
              height: 54px;
              border-radius: 50%;
            }
            .img1 {
              position: absolute;
              left: 50%;
              top: 2px;
              margin-left: -27px;
              z-index: 9;
            }
            .img2 {
              margin-left: -27px;
            }
          }
          .num {
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.45);
            line-height: 34px;
            margin-top: 10px;
          }
        }
      }
      .pt10 {
        padding-top: 10px;
      }
      .footer {
        display: flex;
        align-items: center;
        font {
          padding-left: 2px;
        }
        .p1 {
          font-size: 30px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(238, 31, 31, 1);
        }
        .p2 {
          padding: 2px 0 0 20px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.45);
          flex: 1;
        }
        .spell-btn {
          width: 104px;
          height: 42px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 21px;
          border: 1px solid rgba(183, 183, 183, 1);
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(89, 89, 89, 1);
          line-height: 42px;
          text-align: center;
        }
      }
    }
  }
}
</style>
